export default "__VITE_ASSET__125d1c31__"